<template>
  <a-select
    ref="selectRef"
    v-model:value="selectedData"
    mode="multiple"
    :placeholder="placeholder"
    labelInValue
    allow-clear
    :open="state.showSelectList"
    :options="list"
    option-filter-prop="label"
    :max-tag-count="maxTagCount"
    :max-tag-text-length="maxTagTextLength"
    :class="className"
    @click="state.showSelectList = true"
  >
    <template #maxTagPlaceholder="omittedValues">
      <span style="color: red" :title="titleValue">+ {{ omittedValues.length }} ...</span>
    </template>
    <template #option="{ label, value }">
      <a-checkbox :value="value">{{ label }}</a-checkbox>
    </template>
    <template #dropdownRender="{ menuNode: menu }">
      <div ref="dropDrownRef">
        <a-checkbox
          class="controll-all"
          v-model:checked="state.checkAll"
          :indeterminate="state.indeterminate"
          @change="onCheckAllChange"
        >
          全部
        </a-checkbox>
        <a-divider style="margin: 0" />
        <a-checkbox-group :value="checkedList" class="my-group">
          <v-nodes :vnodes="menu" />
        </a-checkbox-group>
      </div>
    </template>
  </a-select>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "MultipleSelect",
});
</script>

<script lang="ts" setup>
import { reactive, defineProps, ref, watch, computed, PropType } from "vue";
import { onClickOutside } from "@vueuse/core";

const VNodes = (_, { attrs }) => {
  return attrs.vnodes;
};

interface ListItem {
  value: string;
  label: string;
}

interface MultipleState {
  indeterminate: boolean;
  checkAll: boolean;
  showSelectList: boolean;
}

const props = defineProps({
  value: {
    type: Array as PropType<ListItem[]>,
    required: true,
    default: () => [],
  },
  list: {
    type: Array as PropType<ListItem[]>,
    default: () => [],
  },
  placeholder: {
    type: String,
    defautl: "请选择",
  },
  maxTagCount: {
    type: Number,
    default: null,
  },
  maxTagTextLength: {
    type: Number,
    default: null,
  },
  className: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["update:value"]);
const titleValue = computed(() => {
  return props.value.map((item) => item.label).join(",");
});
const selectedData = computed({
  get: () => props.value,
  set(val: ListItem[]) {
    emit("update:value", val);
  },
});

const state = reactive<MultipleState>({
  indeterminate: false,
  checkAll: false,
  showSelectList: false,
});

const checkedList = computed({
  get() {
    return props.value.map((item) => item.value);
  },
  set(val: string[]) {
    // console.log(val, "编辑");
    selectedData.value = props.list.reduce<ListItem[]>((total, ele) => {
      if (val.includes(ele.value)) {
        total.push(ele);
      }
      return total;
    }, []);
  },
});

function onCheckAllChange(e: any) {
  state.indeterminate = false;
  selectedData.value = e.target.checked ? props.list : [];
}

watch(
  () => props.value,
  (val) => {
    state.indeterminate = !!val.length && val.length < props.list.length;
    state.checkAll = val.length === props.list.length;
  }
);

const dropDrownRef = ref(null);
const selectRef = ref(null);

onClickOutside(
  dropDrownRef,
  () => {
    state.showSelectList = false;
  },
  { ignore: [selectRef] }
);
</script>

<style lang="less" scoped>
.controll-all {
  width: 100%;
  padding: 5px 12px;
}

.ant-checkbox-wrapper {
  padding-top: 5px;
  padding-bottom: 5px;
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}

.ant-checkbox-group {
  width: 100%;
  :deep(.ant-select-item-option-state) {
    display: none;
  }
  :deep(.ant-checkbox + span) {
    pointer-events: none;
  }
}
:deep(.rc-virtual-list){
  width: 100%;
}
</style>
